import { logDebug } from "../../../common/utils/logger";

/** Set true to trace ROP/ECBO in console (dev only). */
const DEBUG_QUOTE_TOGGLES = false;

export const debugLog = (...args) => {
  if (DEBUG_QUOTE_TOGGLES && import.meta.env?.DEV) {
    logDebug("[Quote Toggles]", ...args);
  }
};
